// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s-Kp","top":"styles_top__1kvrb"};